import { render } from "./SortIcon.vue?vue&type=template&id=f8e2fdf0&scoped=true"
import script from "./SortIcon.vue?vue&type=script&lang=js"
export * from "./SortIcon.vue?vue&type=script&lang=js"

import "./SortIcon.vue?vue&type=style&index=0&id=f8e2fdf0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8e2fdf0"]])

export default __exports__